import styles from "./Fallback.module.css";
import LaptopImage from "../../../assets/images/base/laptop.png";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { Page } from "../../../helbest";
import { LangLink } from "../LangLink/LangLink";

export default function Fallback() {
  const { t } = useTranslation();
  return (
    <Page
      className="page-404"
      back={true}
      address="/"
      mobileContainer
      noHeader
      headerFix
    >
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img src={LaptopImage} alt="laptop image" />
        </div>
        <p>{t("error_boundary.message")}</p>
        <LangLink to="/">
          <Button type="primary">{t("common.back_home")}</Button>
        </LangLink>
      </div>
    </Page>
  );
}
